import {Component} from '@angular/core';
import {BaseSupportModalComponent} from "./base_support.component";
import {AbstractControl, FormControl, Validators} from "@angular/forms";

@Component({
	templateUrl: './edit_recurrent.component.html'
})
export class EditRecurrentModalComponent extends BaseSupportModalComponent {
	rebillStartDate: string;
	amount: number;
	userCurrency: string;
	siteId: string;
	domainUrl: string;
	recurrentProfile: string;

	ngOnInit() {
		this.spreader.base.form = this.form;

		this.form.addControl('amount', new FormControl('',[
			this.getCustomValidator('amount_number', function(name: string, control: AbstractControl) {
				const isInvalid = !(!isNaN(parseFloat(control.value)) && isFinite(control.value));

				let err = {};
				err[name] = {value: control.value, message: '"Сумма платежа" - должно быть числом'};

				return isInvalid ? err : null;
			}),
			this.getCustomValidator('amount_positive', function(name: string, control: AbstractControl) {
				const isInvalid = !(control.value > 0);

				let err = {};
				err[name] = {value: control.value, message: '"Сумма платежа" - должно быть положительным числом'};

				return isInvalid ? err : null;
			}),
		]));

		this.form.addControl('rebillStartDate', new FormControl('',[
			this.getStandartValidator('rebillStartDate_required', Validators.required, '"Дата начала платежа" - обязательное поле'),
			this.getStandartValidator('rebillStartDate_format', this.CustomValidators.dateFormat('YYYY-MM-DD'), '"Дата начала платежа" - Неверный(YYYY-MM-DD) формат даты'),
			this.getStandartValidator('rebillStartDate_min', this.CustomValidators.dateNotBeforeToday('YYYY-MM-DD'), '"Дата начала платежа" - Дата не может быть меньше текущей'),
		]));
	}

	async ok() {
		this.isBtnOkActive = false;
		if (confirm(`Вы уверены, что хотите изменить данные подписки для сайта ${this.domainUrl}?`)) {

			await this.supportService.editRecurrentProfile(this.siteId, this.rebillStartDate, this.amount * 100.00, this.comment).toPromise();

			this.execute();
		}
		this.isBtnOkActive = true;
	}
}
